import { RoomAcl, RoomAclGroups, RoomAclMembers } from '@era/locations-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RoomPermissionsResolverActions = createActionGroup({
  source: 'Room Permissions Resolver',
  events: {
    'Room acl requested': props<{ resourceId: string; floorResourceId: string; locationResourceId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AccessControlListApiActions = createActionGroup({
  source: 'Access Control List Controller',
  events: {
    'Room acl loaded': props<{ roomAcl: RoomAcl }>(),
    'Room acl loaded error': props<{ error: ErrorModel }>(),
    'Room acl member put': props<{ aclMember: RoomAclMembers }>(),
    'Room acl group put': props<{ aclGroup: RoomAclGroups }>(),
    'Room acl group remove': props<{ aclGroup: RoomAclGroups }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RoomAclPermissionsUiActions = createActionGroup({
  source: 'Room Settings Acl Permissions Component',
  events: {
    'Room acl member put': props<{ aclMember: RoomAclMembers }>(),
    'Room acl group put': props<{ aclGroup: RoomAclGroups }>(),
    'Room acl group remove': props<{ aclGroup: RoomAclGroups }>(),
  },
});
